import type { EthereumAddress, WEIString, } from "@bracket/types";


export const getStoredClaim = async ( wallet: EthereumAddress, ): Promise<{ amount: WEIString; claimed: boolean; proof: string[]; } | null> => {
	const query = `{ checkin(wallet:"${wallet}"){ address claim { amount claimed proof } } }`;
	const response = await fetch("/api/vaults/graphql", {
		method: "POST",
		body: JSON.stringify({ query, }),
		headers: {
			"Content-Type": "application/json",
			wallet: wallet,
		},
	});
	if(response.ok) {
		const { data } = await response.json();
		return data.checkin.claim;
	}
	return null;
};
